export type ContractRecalculationFormValues = {
    durationValue: number;
    distanceValue: number;
    comment: string;
};

export const boundry = {
    duration: {
        maximum: 60,
        minimum: 0,
    },
    distance: {
        maximum: 200000,
        minimum: 0,
    },
};

export const getInitialValues = (currentMileage: number, currentDuration: number): ContractRecalculationFormValues => ({
    durationValue: currentDuration,
    distanceValue: currentMileage,
    comment: '',
});
